export const DoctorList = [
    {
        id:1,
        image:"/Images/About/Doctor1.webp",
        name:"Dr. S. Sabari Raja",
        degree:"M.B.B.S., D.C.H., PGDN",
        speaclist:"Consultant Pediatrician and Neonatologist",
        position:"Chairman & Executive Director"
    },
    {
        id:2,
        image:"/Images/About/Doctor2.webp",
        name:"Dr. S. Hemavathi",
        degree:"M.B.B.S., D.G.O., FMAS, FART",
        speaclist:"Consultant Obstetrician & Gynaecologist",
        position:"Laproscopy and Infertility Specialist"
    },
];